import React from 'react';
import { translate } from '../../Services/translation';
import '../../../images/certificate-1.png';
import '../../../images/certificate-2.png';
import '../../../images/certificate-3.png';
import '../../../images/certificate-4.png';
import '../../../images/certificate-5.png';
import '../../../images/certificate-6.png';
import '../../../images/certificate-7.svg';
import '../../../images/easy-up-quality.png';

interface ceritificateListProps {
  certificateList: string[];
  itemIsEasyUp: boolean;
}

const Certificates = ({
  certificateList,
  itemIsEasyUp,
}: ceritificateListProps) => {
  const svgCertificates = ['7'];

  return (
    <div className="flex flex-col gap-4">
      {itemIsEasyUp && (
        <div className="flex gap-4" key="ease-up">
          <img
            className="h-14 w-14 min-w-[3.5rem] object-contain"
            alt="easy-up-logo"
            src={'/ui/images/easy-up-quality.png'}
          />
          <div className="flex flex-col text-lg">
            <span className="font-medium text-gray-700">
              {translate(`certificates.title-easy-up`)}
            </span>
            <span className="font-light text-gray-700">
              {translate(`certificates.desciption-easy-up`)}
            </span>
          </div>
        </div>
      )}
      {certificateList?.map((cert, idx) => (
        <div className="flex gap-4" key={idx + cert.valueOf() + 'cert'}>
          <img
            className="h-14 w-14 min-w-[3.5rem] object-contain"
            alt="certificate-logo"
            src={
              '/ui/images/certificate-' +
              cert.valueOf() +
              (svgCertificates.includes(cert.valueOf()) ? '.svg' : '.png')
            }
          />
          <div className="flex flex-col text-lg">
            <span className="font-medium text-gray-700">
              {translate(`certificates.title-${cert.valueOf()}`)}
            </span>
            <span className="font-light text-gray-700">
              {translate(`certificates.desciption-${cert.valueOf()}`)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Certificates;
